import { z } from 'zod';
import { Role } from '../enums';
import { emailSchema, nameSchema, paginationQuerySchema, uuidSchema } from './common';
export const updateUserSchema = z.object({
    name: nameSchema.optional(),
    avatarMediaId: uuidSchema.nullish(),
});
/**
 * Role changes are their own endpoint rather than a field on the general update.
 *
 * Privilege escalation deserves a distinct permission (`role:assign`), a
 * dedicated audit entry, and a signature that makes it impossible to change
 * somebody's role as an unnoticed side effect of a profile edit.
 */
export const changeUserRoleSchema = z.object({
    role: z.enum(Role),
});
/**
 * Accounts are deactivated, never deleted.
 *
 * Posts, media and audit entries reference their author. Hard-deleting a user
 * would either orphan that history or cascade it away — both of which destroy
 * the record of who did what. Deactivation revokes access and leaves the trail
 * intact.
 */
export const setUserActiveSchema = z.object({
    isActive: z.boolean(),
});
export const userQuerySchema = paginationQuerySchema.extend({
    q: z.string().trim().max(120).optional(),
    role: z.enum(Role).optional(),
    isActive: z.coerce.boolean().optional(),
});
export const adminCreateUserSchema = z.object({
    email: emailSchema,
    name: nameSchema,
    role: z.enum(Role),
});
//# sourceMappingURL=user.js.map